import { TextLinkStyle } from '@nextgen-web-framework/all';
import { IconName } from '@fortawesome/fontawesome-svg-core';

interface Action {
  text: string;
  callbackFunction: () => void;
  textLinkStyle?: TextLinkStyle;
  icon?: IconName;
}

export enum Version {
  V1 = 'V1',
  V2 = 'V2',
}

interface SubHeaderProps {
  headingText: string;
  actions?: Action[];
  version?: Version;
}

export default SubHeaderProps;
